module.exports = __webpack_public_path__ + "static/wizard-cutout-3f2cbdd6c13c4bc2dc8f1edc63587d13.png";